export var RouteServiceEvent;
(function (RouteServiceEvent) {
    RouteServiceEvent["RouteChanged"] = "route-changed";
})(RouteServiceEvent || (RouteServiceEvent = {}));
